export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_ENUM = 'enum';
export const FIELD_TYPE_INTEGER = 'integer';
export const FIELD_TYPE_FLOAT = 'float';
export const FIELD_TYPE_MULTISELECT = 'multiSelect';
export const FIELD_TYPE_STRING = 'string';
//# sourceMappingURL=constants.js.map